var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FFE0EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14H10V28C10 29.1 10.9 30 12 30H26V28H12V14ZM28 10H16C14.9 10 14 10.9 14 12V24C14 25.1 14.9 26 16 26H28C29.1 26 30 25.1 30 24V12C30 10.9 29.1 10 28 10ZM28 24H16V12H28V24ZM21.51 18.16C21.92 17.43 22.69 17 23.14 16.36C23.62 15.68 23.35 14.42 22 14.42C21.12 14.42 20.68 15.09 20.5 15.65L19.13 15.08C19.51 13.96 20.52 13 21.99 13C23.22 13 24.07 13.56 24.5 14.26C24.87 14.86 25.08 15.99 24.51 16.83C23.88 17.76 23.28 18.04 22.95 18.64C22.82 18.88 22.77 19.04 22.77 19.82H21.25C21.26 19.41 21.19 18.74 21.51 18.16ZM20.95 21.95C20.95 21.36 21.42 20.91 22 20.91C22.59 20.91 23.04 21.36 23.04 21.95C23.04 22.53 22.6 23 22 23C21.42 23 20.95 22.53 20.95 21.95Z",
    fill: "#FC5ABB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionico);
export default __webpack_public_path__ + "static/media/questionico.a1ac6241c85096efc49b907245e7ab71.svg";
export { ForwardRef as ReactComponent };